import FooterRow               from './Base/Footer/FooterRow';
import FooterColumn            from './Base/Footer/FooterColumn';
import FooterLabel             from './Base/Footer/FooterLabel';
import Footer                  from './Base/Footer/Footer';
import React                   from 'react';
import Flux                    from '../../../flux/Flux';
import {TileDisplayConfigType} from '../Grid2';
import PropTypes               from 'prop-types';
import Translations            from "../../../utils/Translations";

const FooterLabelStyles = Flux.Constants.Grid2.Footer.Label.Styles;

const TVSeriesTileFooter = props => {
	const data          = props.data;
	const displayConfig = props.displayConfig;

	if (!props.hovering) {
		return null;
	}

	return (
		<Footer displayConfig={displayConfig} additionalClasses={["grid-2__tile__type-tv-series__footer"]}>
			<FooterRow>
				<FooterRow shrink={true} grow={true}>
					<i className="grid-2__tile__type-tv-series__footer-icon icon -icon-videotake-full" />
					<FooterColumn grow={true} shrink={true}>
						<FooterRow>
							<FooterLabel labelStyle={FooterLabelStyles.TITLE}>
								<h3>{data.title}</h3>
							</FooterLabel>
						</FooterRow>
						<FooterRow>
							<FooterColumn grow={true} shrink={true}>
								<FooterRow>
									<FooterLabel labelStyle={FooterLabelStyles.SUBTITLE}>
										{data.episodeCount + ' ' + Translations.get('TVMediathekEpisodes')}
									</FooterLabel>
								</FooterRow>
							</FooterColumn>
						</FooterRow>
					</FooterColumn>
				</FooterRow>
			</FooterRow>
		</Footer>
	);
};


TVSeriesTileFooter.propTypes = {
	data:          PropTypes.object.isRequired, // VXQL tv series type
	hovering:      PropTypes.bool.isRequired,
	config:        PropTypes.object,
	displayConfig: TileDisplayConfigType,
};

TVSeriesTileFooter.defaultProps = {
	hovering: false,
};

export default TVSeriesTileFooter;